module.exports = __webpack_public_path__ + "static/media/framesshapes-1.ee3c8aef.mp4";